<button  class="custom-btn d-flex justify-content-center align-items-center"
   [ngClass]="{ 'custom-btn-dark': modoDark }" 
   (click)="emitirEvento()" 
   [disabled]="disabled"
   [ngStyle]="{ 'opacity': disabled ? '0.3' : '1' , 'cursor': disabled ? 'not-allowed' : 'pointer' }"
   > 
  <img *ngIf="imagemBtn != null" class="me-2" [src]="imagemBtn" > {{ titulo }} </button>